/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_KreditinstitutInputs */

const de__field_kreditinstitut = /** @type {(inputs: _Field_KreditinstitutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreditinstitut`)
};

/**

* @param {_Field_KreditinstitutInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_kreditinstitut = /** @type {((inputs?: _Field_KreditinstitutInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_KreditinstitutInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kreditinstitut(inputs)
});